import { createAction } from '@reduxjs/toolkit'
import { AppTokens } from './types'

export function logoutAction(): { type: string } {
  return {
    type: 'RESET_STATE'
  }
}

export const loginAction = createAction<{
  user: Record<string, unknown>
  token: AppTokens
}>('authentication/LOGIN')

export const setAppTokens = createAction<AppTokens | null>('authentication/SET_TOKEN')

export const setUserAction = createAction<Record<string, unknown>>('authentication/SET_USER')
